import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Checkbox } from "@material-ui/core";
import { Search } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    fontSize: 13,
    marginLeft:-5
  },
}));
export default function BrandItem({ handleChange, index, value, checked }) {
  const classes = useStyles();
  const handleLocalChange = (e) => {
    handleChange(e, index);
  };
  return (
    <>
      <div className={classes.container}>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "primary checkbox" }}
        />
        <p className={classes.title}>Testing mobile</p>
      </div>
    </>
  );
}
